import { WidgetPlugin } from '@sagold/react-json-editor';

import { MultiSelectOption } from '../components/selects/MultiSelect';

import { ArrayWidgetPlugin } from './widgets/arraywidget/ArrayWidget';
import { BooleanWidgetPlugin } from './widgets/booleanwidget/BooleanWidget';
import { CreatableSelectWidgetPlugin } from './widgets/creatableselectwidget/CreatableSelectWidget';
import { DateWidgetPlugin } from './widgets/datewidget/DateWidget';
import { ExcludeSelectionWidgetPlugin } from './widgets/excludeselectionwidget/ExcludeSelectionWidget';
import { MonthPickerWidgetPlugin } from './widgets/monthpickerwidget/MonthPickerWidget';
import { MonthQuarterPickerWidgetPlugin } from './widgets/monthquarterpickerwidget/MonthQuarterPickerWidget';
import {
  MultiSelectWidgetPlugin,
  MultiSelectWidgetPluginWrapper,
} from './widgets/multiselectwidget/MultiSelectWidget';
import { NullWidgetPlugin } from './widgets/nullwidget/NullWidget';
import { NumberWidgetPlugin } from './widgets/numberwidget/NumberWidget';
import { ObjectWidgetPlugin } from './widgets/objectwidget/ObjectWidget';
import { QuarterPickerWidgetPlugin } from './widgets/quarterpickerwidget/QuarterPickerWidget';
import { ReferencedKeywordWidgetPlugin } from './widgets/referencedkeywordwidget/ReferencedKeywordWidget';
import { SelectWidgetPlugin } from './widgets/selectwidget/SelectWidget';
import { StringWidgetPlugin } from './widgets/stringwidget/StringWidget';
import { TabWidgetPlugin } from './widgets/tabwidget/TabWidget';
import { TextareaWidgetPlugin } from './widgets/textareawidget/TextareaWidget';
import { UnknownWidgetPlugin } from './widgets/unknownwidget/UnknownWidget';

import './json-editor.scss';

export const jsonEditorWidgets: WidgetPlugin[] = [
  {
    id: 'hidden-widget',
    use: (node) => node.options?.hidden,
    Widget: () => null,
  },
  TabWidgetPlugin,
  ExcludeSelectionWidgetPlugin,
  ReferencedKeywordWidgetPlugin,
  MonthPickerWidgetPlugin,
  QuarterPickerWidgetPlugin,
  MonthQuarterPickerWidgetPlugin,
  DateWidgetPlugin,
  MultiSelectWidgetPlugin,
  CreatableSelectWidgetPlugin,
  SelectWidgetPlugin,
  ArrayWidgetPlugin,
  ObjectWidgetPlugin,
  TextareaWidgetPlugin,
  StringWidgetPlugin,
  NumberWidgetPlugin,
  BooleanWidgetPlugin,
  NullWidgetPlugin,
  UnknownWidgetPlugin,
];

export const jsonEditorWidgetsWrapper = (
  sortCallback?: (a: MultiSelectOption, b: MultiSelectOption) => number
): WidgetPlugin[] => {
  return [
    {
      id: 'hidden-widget',
      use: (node) => node.options?.hidden,
      Widget: () => null,
    },
    TabWidgetPlugin,
    ExcludeSelectionWidgetPlugin,
    ReferencedKeywordWidgetPlugin,
    MonthPickerWidgetPlugin,
    QuarterPickerWidgetPlugin,
    MonthQuarterPickerWidgetPlugin,
    DateWidgetPlugin,
    MultiSelectWidgetPluginWrapper(sortCallback),
    CreatableSelectWidgetPlugin,
    SelectWidgetPlugin,
    ArrayWidgetPlugin,
    ObjectWidgetPlugin,
    TextareaWidgetPlugin,
    StringWidgetPlugin,
    NumberWidgetPlugin,
    BooleanWidgetPlugin,
    NullWidgetPlugin,
    UnknownWidgetPlugin,
  ];
};
